export default "__VITE_ASSET__2d5baa87__"